import { render, staticRenderFns } from "./modalCategorias.vue?vue&type=template&id=3401a2c2&scoped=true&"
import script from "./modalCategorias.vue?vue&type=script&lang=js&"
export * from "./modalCategorias.vue?vue&type=script&lang=js&"
import style0 from "./modalCategorias.vue?vue&type=style&index=0&id=3401a2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3401a2c2",
  null
  
)

export default component.exports